import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { UserPreferences } from '../models/user.model';

export interface UpdatePreferencesRequest {
  preferences: Partial<UserPreferences>;
}

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {
  private readonly endpoint = '/api/users';

  constructor(private apiService: ApiService) {}

  /**
   * Récupérer les préférences d'un utilisateur
   */
  getUserPreferences(userId: number): Observable<{ success: boolean; data: UserPreferences }> {
    return this.apiService.get(`${this.endpoint}/${userId}/preferences`);
  }

  /**
   * Mettre à jour les préférences d'un utilisateur
   */
  updateUserPreferences(userId: number, preferences: Partial<UserPreferences>): Observable<{ success: boolean; data: UserPreferences; message: string }> {
    const request: UpdatePreferencesRequest = { preferences };
    return this.apiService.put(`${this.endpoint}/${userId}/preferences`, request);
  }
}
